import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getBreakdownOfPremuimsByPurchesSource,
  getCurrentPremiumCount,
  getDailyBreakdownByPurchesSource,
  getFirstTimeSubscriptionCount,
  getPromoCodeAliasBreakdownBySource,
  getUserRetentionForMultiplePoints,
  getFirstTimeSubscriptionBreakdownByWeeks,
  getDailyAquiredPremiumUsers,
  getDailyLostPremiumUsers,
  getDailyBreakdownByPurchesFilteredSource,
  getExpectedToBeLostPremiums,
  getDailyFirstTimeSubscription,
  getDailyUpgradeSubscription,
  getDailyDowngradeSubscription,
  getDailyRefunds,
  getdailyChurnedPremiumUsers,
  getdailyReactivedPremiumUsers,
  getDailyFaildToRenewPremiumUsers,
  getDailyPromoCodeAlias,
} from './thunks';
import { PaymentAnalysisState } from './types';

export const name = 'paymentAnalysis';

const initialState: PaymentAnalysisState = {
  currentPremuimCount: 0,
  dailyBreakdownByPurchaseSurce: [],
  dailyBreakdownByPurchaseSurceFiltered: [],
  breakDownofPremiumByPurchaseSurce: [],
  firstTimeSubscriptionBreakdownByWeek: [],
  firstTimeSubscriptionCount: 0,
  promoCodeAliasBreakdownBySource: [],
  userRetentionForMultiplePoints: [],
  dailyAquiredPremiumUsers: {
    days: [],
    sum: 0,
  },
  dailyLostPremiumUsers: [],
  expectedToBeLostPremiums: null,
  dailyFirstTimeSubscription: null,
  dailyUpgradeSubscription: null,
  dailyDowngradeSubscription: null,
  // dailyRefunds: null,
  dailyChurnedPremiumUsers: null,
  dailyReactivedPremiumUsers: null,
  dailyFaildToRenewPremiumUsers: null,
  // dailyPromoCodeAlias: [],

  currentPremuimCountStatus: 'idle',
  dailyBreakdownByPurchaseSurceStatus: 'idle',
  dailyBreakdownByPurchaseSurceFilteredStatus: 'idle',
  breakDownofPremiumByPurchaseSurceStatus: 'idle',
  firstTimeSubscriptionBreakdownByWeekStatus: 'idle',
  firstTimeSubscriptionCountStatus: 'idle',
  promoCodeAliasBreakdownBySourceStatus: 'idle',
  userRetentionForMultiplePointsStatus: 'idle',
  dailyAquiredPremiumUsersStatus: 'idle',
  dailyLostPremiumUsersStatus: 'idle',
  expectedToBeLostPremiumsStatus: 'idle',
  dailyFirstTimeSubscriptionStatus: 'idle',
  dailyUpgradeSubscriptionStatus: 'idle',
  dailyDowngradeSubscriptionStatus: 'idle',
  dailyRefundsStatus: 'idle',
  dailyChurnedPremiumUsersStatus: 'idle',
  dailyReactivedPremiumUsersStatus: 'idle',
  dailyFaildToRenewPremiumUsersStatus: 'idle',
  dailyPromoCodeAliasStatus: 'idle',
};
export const getBreakdownOfPremuimsByPurchesSourceAsync = createAsyncThunk(
  name + '/getBreakdownOfPremuimsByPurchesSource',
  getBreakdownOfPremuimsByPurchesSource
);

export const getCurrentPremiumCountAsync = createAsyncThunk(
  name + '/getCurrentPremiumCount',
  getCurrentPremiumCount
);

export const getDailyBreakdownByPurchesSourceAsync = createAsyncThunk(
  name + '/getDailyBreakdownByPurchesSource',
  getDailyBreakdownByPurchesSource
);

export const getFirstTimeSubscriptionCountAsync = createAsyncThunk(
  name + '/getFirstTimeSubscriptionCount',
  getFirstTimeSubscriptionCount
);

export const getPromoCodeAliasBreakdownBySourceAsync = createAsyncThunk(
  name + '/getPromoCodeAliasBreakdownBySource',
  getPromoCodeAliasBreakdownBySource
);

export const getUserRetentionForMultiplePointsAsync = createAsyncThunk(
  name + '/getUserRetentionForMultiplePoints',
  getUserRetentionForMultiplePoints
);

export const getFirstTimeSubscriptionBreakdownByWeeksAsync = createAsyncThunk(
  name + '/getFirstTimeSubscriptionBreakdownByWeeks',
  getFirstTimeSubscriptionBreakdownByWeeks
);

export const getDailyAquiredPremiumUsersAsync = createAsyncThunk(
  name + '/getDailyAquiredPremiumUsers',
  getDailyAquiredPremiumUsers
);

export const getDailyLostPremiumUsersAsync = createAsyncThunk(
  name + '/getDailyLostPremiumUsers',
  getDailyLostPremiumUsers
);

export const getDailyBreakdownByPurchesFilteredSourceAsync = createAsyncThunk(
  name + '/getDailyBreakdownByPurchesFilteredSource',
  getDailyBreakdownByPurchesFilteredSource
);
export const getExpectedToBeLostPremiumsAsync = createAsyncThunk(
  name + '/getExpectedToBeLostPremiums',
  getExpectedToBeLostPremiums
);

export const getDailyFirstTimeSubscriptionAsync = createAsyncThunk(
  name + '/getDailyFirstTimeSubscription',
  getDailyFirstTimeSubscription
);

export const getDailyUpgradeSubscriptionAsync = createAsyncThunk(
  name + '/getDailyUpgradeSubscription',
  getDailyUpgradeSubscription
);

export const getDailyDowngradeSubscriptionAsync = createAsyncThunk(
  name + '/getDailyDowngradeSubscription',
  getDailyDowngradeSubscription
);

export const getDailyRefundsAsync = createAsyncThunk(
  name + '/getDailyRefunds',
  getDailyRefunds
);

export const getdailyChurnedPremiumUsersAsync = createAsyncThunk(
  name + '/getdailyChurnedPremiumUsers',
  getdailyChurnedPremiumUsers
);

export const getdailyReactivedPremiumUsersAsync = createAsyncThunk(
  name + '/getdailyReactivedPremiumUsers',
  getdailyReactivedPremiumUsers
);

export const getDailyFaildToRenewPremiumUsersAsync = createAsyncThunk(
  name + '/getDailyFaildToRenewPremiumUsers',
  getDailyFaildToRenewPremiumUsers
);

export const getDailyPromoCodeAliasAsync = createAsyncThunk(
  name + '/getDailyPromoCodeAlias',
  getDailyPromoCodeAlias
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBreakdownOfPremuimsByPurchesSourceAsync.pending, (state) => {
        state.breakDownofPremiumByPurchaseSurceStatus = 'loading';
      })
      .addCase(
        getBreakdownOfPremuimsByPurchesSourceAsync.fulfilled,
        (state, action) => {
          state.breakDownofPremiumByPurchaseSurceStatus = 'idle';
          state.breakDownofPremiumByPurchaseSurce = action.payload;
        }
      )
      .addCase(getBreakdownOfPremuimsByPurchesSourceAsync.rejected, (state) => {
        state.breakDownofPremiumByPurchaseSurceStatus = 'failed';
      })
      .addCase(getCurrentPremiumCountAsync.pending, (state) => {
        state.currentPremuimCountStatus = 'loading';
      })
      .addCase(getCurrentPremiumCountAsync.fulfilled, (state, action) => {
        state.currentPremuimCountStatus = 'idle';
        state.currentPremuimCount = action.payload;
      })
      .addCase(getCurrentPremiumCountAsync.rejected, (state) => {
        state.currentPremuimCountStatus = 'failed';
      })
      .addCase(getDailyBreakdownByPurchesSourceAsync.pending, (state) => {
        state.dailyBreakdownByPurchaseSurceStatus = 'loading';
      })
      .addCase(
        getDailyBreakdownByPurchesSourceAsync.fulfilled,
        (state, action) => {
          state.dailyBreakdownByPurchaseSurceStatus = 'idle';
          state.dailyBreakdownByPurchaseSurce = action.payload;
        }
      )
      .addCase(getDailyBreakdownByPurchesSourceAsync.rejected, (state) => {
        state.dailyBreakdownByPurchaseSurceStatus = 'failed';
      })
      .addCase(getFirstTimeSubscriptionCountAsync.pending, (state) => {
        state.firstTimeSubscriptionCountStatus = 'loading';
      })
      .addCase(
        getFirstTimeSubscriptionCountAsync.fulfilled,
        (state, action) => {
          state.firstTimeSubscriptionCountStatus = 'idle';
          state.firstTimeSubscriptionCount = action.payload;
        }
      )
      .addCase(getFirstTimeSubscriptionCountAsync.rejected, (state) => {
        state.firstTimeSubscriptionCountStatus = 'failed';
      })
      .addCase(getPromoCodeAliasBreakdownBySourceAsync.pending, (state) => {
        state.promoCodeAliasBreakdownBySourceStatus = 'loading';
      })
      .addCase(
        getPromoCodeAliasBreakdownBySourceAsync.fulfilled,
        (state, action) => {
          state.promoCodeAliasBreakdownBySourceStatus = 'idle';
          state.promoCodeAliasBreakdownBySource = action.payload;
        }
      )
      .addCase(getPromoCodeAliasBreakdownBySourceAsync.rejected, (state) => {
        state.promoCodeAliasBreakdownBySourceStatus = 'failed';
      })
      .addCase(getUserRetentionForMultiplePointsAsync.pending, (state) => {
        state.userRetentionForMultiplePointsStatus = 'loading';
      })
      .addCase(
        getUserRetentionForMultiplePointsAsync.fulfilled,
        (state, action) => {
          state.userRetentionForMultiplePointsStatus = 'idle';
          state.userRetentionForMultiplePoints = action.payload;
        }
      )
      .addCase(getUserRetentionForMultiplePointsAsync.rejected, (state) => {
        state.userRetentionForMultiplePointsStatus = 'failed';
      })
      .addCase(
        getFirstTimeSubscriptionBreakdownByWeeksAsync.pending,
        (state) => {
          state.firstTimeSubscriptionBreakdownByWeekStatus = 'loading';
        }
      )
      .addCase(
        getFirstTimeSubscriptionBreakdownByWeeksAsync.fulfilled,
        (state, action) => {
          state.firstTimeSubscriptionBreakdownByWeekStatus = 'idle';
          state.firstTimeSubscriptionBreakdownByWeek = action.payload;
        }
      )

      .addCase(
        getFirstTimeSubscriptionBreakdownByWeeksAsync.rejected,
        (state) => {
          state.firstTimeSubscriptionBreakdownByWeekStatus = 'failed';
        }
      )
      .addCase(getDailyAquiredPremiumUsersAsync.pending, (state) => {
        state.dailyAquiredPremiumUsersStatus = 'loading';
      })
      .addCase(getDailyAquiredPremiumUsersAsync.fulfilled, (state, action) => {
        state.dailyAquiredPremiumUsersStatus = 'idle';
        state.dailyAquiredPremiumUsers = action.payload;
      })
      .addCase(getDailyAquiredPremiumUsersAsync.rejected, (state) => {
        state.dailyAquiredPremiumUsersStatus = 'failed';
      })
      .addCase(getDailyLostPremiumUsersAsync.pending, (state) => {
        state.dailyLostPremiumUsersStatus = 'loading';
      })

      .addCase(getDailyLostPremiumUsersAsync.fulfilled, (state, action) => {
        state.dailyLostPremiumUsersStatus = 'idle';
        state.dailyLostPremiumUsers = action.payload;
      })
      .addCase(getDailyLostPremiumUsersAsync.rejected, (state) => {
        state.dailyLostPremiumUsersStatus = 'failed';
      })
      .addCase(
        getDailyBreakdownByPurchesFilteredSourceAsync.pending,
        (state) => {
          state.dailyBreakdownByPurchaseSurceFilteredStatus = 'loading';
        }
      )
      .addCase(
        getDailyBreakdownByPurchesFilteredSourceAsync.fulfilled,
        (state, action) => {
          state.dailyBreakdownByPurchaseSurceFilteredStatus = 'idle';
          state.dailyBreakdownByPurchaseSurceFiltered = action.payload;
        }
      )
      .addCase(
        getDailyBreakdownByPurchesFilteredSourceAsync.rejected,
        (state) => {
          state.dailyBreakdownByPurchaseSurceFilteredStatus = 'failed';
        }
      )

      .addCase(getExpectedToBeLostPremiumsAsync.pending, (state) => {
        state.expectedToBeLostPremiumsStatus = 'loading';
      })
      .addCase(getExpectedToBeLostPremiumsAsync.fulfilled, (state, action) => {
        state.expectedToBeLostPremiumsStatus = 'idle';
        state.expectedToBeLostPremiums = action.payload;
      })
      .addCase(getExpectedToBeLostPremiumsAsync.rejected, (state) => {
        state.expectedToBeLostPremiumsStatus = 'failed';
      })
      .addCase(getDailyFirstTimeSubscriptionAsync.pending, (state) => {
        state.dailyFirstTimeSubscriptionStatus = 'loading';
      })
      .addCase(
        getDailyFirstTimeSubscriptionAsync.fulfilled,
        (state, action) => {
          state.dailyFirstTimeSubscriptionStatus = 'idle';
          state.dailyFirstTimeSubscription = action.payload;
        }
      )
      .addCase(getDailyFirstTimeSubscriptionAsync.rejected, (state) => {
        state.dailyFirstTimeSubscriptionStatus = 'failed';
      })
      .addCase(getDailyUpgradeSubscriptionAsync.pending, (state) => {
        state.dailyUpgradeSubscriptionStatus = 'loading';
      })
      .addCase(getDailyUpgradeSubscriptionAsync.fulfilled, (state, action) => {
        state.dailyUpgradeSubscriptionStatus = 'idle';
        state.dailyUpgradeSubscription = action.payload;
      })
      .addCase(getDailyUpgradeSubscriptionAsync.rejected, (state) => {
        state.dailyUpgradeSubscriptionStatus = 'failed';
      })
      .addCase(getDailyDowngradeSubscriptionAsync.pending, (state) => {
        state.dailyDowngradeSubscriptionStatus = 'loading';
      })
      .addCase(
        getDailyDowngradeSubscriptionAsync.fulfilled,
        (state, action) => {
          state.dailyDowngradeSubscriptionStatus = 'idle';
          state.dailyDowngradeSubscription = action.payload;
        }
      )
      .addCase(getDailyDowngradeSubscriptionAsync.rejected, (state) => {
        state.dailyDowngradeSubscriptionStatus = 'failed';
      })
      // .addCase(getDailyRefundsAsync.pending, (state) => {
      //   state.dailyRefundsStatus = 'loading';
      // })
      // .addCase(getDailyRefundsAsync.fulfilled, (state, action) => {
      //   state.dailyRefundsStatus = 'idle';
      //   state.dailyRefunds = action.payload;
      // })
      // .addCase(getDailyRefundsAsync.rejected, (state) => {
      //   state.dailyRefundsStatus = 'failed';
      // })
      .addCase(getdailyChurnedPremiumUsersAsync.pending, (state) => {
        state.dailyChurnedPremiumUsersStatus = 'loading';
      })
      .addCase(getdailyChurnedPremiumUsersAsync.fulfilled, (state, action) => {
        state.dailyChurnedPremiumUsersStatus = 'idle';
        state.dailyChurnedPremiumUsers = action.payload;
      })
      .addCase(getdailyChurnedPremiumUsersAsync.rejected, (state) => {
        state.dailyChurnedPremiumUsersStatus = 'failed';
      })
      .addCase(getdailyReactivedPremiumUsersAsync.pending, (state) => {
        state.dailyReactivedPremiumUsersStatus = 'loading';
      })
      .addCase(
        getdailyReactivedPremiumUsersAsync.fulfilled,
        (state, action) => {
          state.dailyReactivedPremiumUsersStatus = 'idle';
          state.dailyReactivedPremiumUsers = action.payload;
        }
      )
      .addCase(getdailyReactivedPremiumUsersAsync.rejected, (state) => {
        state.dailyReactivedPremiumUsersStatus = 'failed';
      })
      .addCase(getDailyFaildToRenewPremiumUsersAsync.pending, (state) => {
        state.dailyFaildToRenewPremiumUsersStatus = 'loading';
      })
      .addCase(
        getDailyFaildToRenewPremiumUsersAsync.fulfilled,
        (state, action) => {
          state.dailyFaildToRenewPremiumUsersStatus = 'idle';
          state.dailyFaildToRenewPremiumUsers = action.payload;
        }
      )
      .addCase(getDailyFaildToRenewPremiumUsersAsync.rejected, (state) => {
        state.dailyFaildToRenewPremiumUsersStatus = 'failed';
      });
    // .addCase(getDailyPromoCodeAliasAsync.pending, (state) => {
    //   state.dailyPromoCodeAliasStatus = 'loading';
    // })
    // .addCase(getDailyPromoCodeAliasAsync.fulfilled, (state, action) => {
    //   state.dailyPromoCodeAliasStatus = 'idle';
    //   state.dailyPromoCodeAlias = action.payload;
    // })
    // .addCase(getDailyPromoCodeAliasAsync.rejected, (state) => {
    //   state.dailyPromoCodeAliasStatus = 'failed';
    // });
  },
});

export const actions = slice.actions;

export default slice.reducer;
